/// <amd-module name="Build/Admin/Checks/Stores/SelectionStore" />
import { Store } from "VSS/Reflux/Store";

import { TaskAgentQueue, TaskAgentPool } from "DistributedTask/Client/Contracts/TaskAgent";

import { PoolHubViewKeys } from "Build/Admin/Common/Constants";

export interface ISelectionState {
    selectedAgentPool: TaskAgentPool | undefined;
    selectedAgentQueue: TaskAgentQueue | undefined;
    selectedTabId: string;
}

export class SelectionStore extends Store {
    public state: ISelectionState = {
        selectedAgentPool: undefined,
        selectedAgentQueue: undefined,
        selectedTabId: PoolHubViewKeys.Jobs
    };

    constructor() {
        super("SelectionStoreChanged");
    }

    public updateSelectedAgentPool = (newAgentPool: TaskAgentPool | undefined) => {
        this.state = {
            ...this.state,
            selectedAgentPool: newAgentPool
        };
        this.emitChanged();
    }

    public updateSelectedAgentQueue = (newAgentQueue: TaskAgentQueue | undefined) => {
        this.state = {
            ...this.state,
            selectedAgentQueue: newAgentQueue
        };
        this.emitChanged();
    }

    public updateSelectedTab = (newTabId: string) => {
        this.state = {
            ...this.state,
            selectedTabId: newTabId
        };
        this.emitChanged();
    }
}
